import { render, staticRenderFns } from "./InventoryAction.vue?vue&type=template&id=68dcdeb2&scoped=true&"
import script from "./InventoryAction.vue?vue&type=script&lang=ts&"
export * from "./InventoryAction.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryAction.vue?vue&type=style&index=0&id=68dcdeb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dcdeb2",
  null
  
)

export default component.exports